import * as Sentry from '@sentry/browser';
import { User } from '@sentry/browser';

const targets = [
  'https://api.shipper.superdispatch.com',
  'https://media.superdispatch.com',
];

export function init() {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    release: import.meta.env.VITE_RELEASE_VERSION,
    environment: import.meta.env.VITE_TARGET,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.extraErrorDataIntegration(),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [400, 599],
        failedRequestTargets: targets,
      }),
    ],
    tracesSampleRate:
      import.meta.env.VITE_APP_TARGET === 'production' ? 1 : 0.1,
    tracePropagationTargets: targets,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
  });
}

export function identifyUser(user: User) {
  Sentry.setUser(user);
}

export function cleanUser() {
  Sentry.setUser(null);
}

export function getLogger() {
  return Sentry.logger;
}

export function addContext(key: string, data: Record<string, unknown>) {
  Sentry.setExtra(key, data);
}
